module.exports = __webpack_public_path__ + "img/productivity.f3349f6d.png";